<template>
  <transition name="slide-fade">
    <div class="ScrollToTop" @click="scrollToTop" v-if="display">
      <svg v-svg symbol="Arrow_Up" size="0 0 24 24" role="presentation" class="icon--inline"></svg>
    </div>
  </transition>
</template>

<script>
import debounce from "lodash/debounce";
import "@/components/ScrollToTop/ScrollToTop.scss";

export default {
  name: "ScrollToTop",

  data () {
    return {
      display: false,
    };
  },

  mounted () {
    this.handleScrollForDisplay();
    this.handleDebouncedScrollDisplay = debounce(this.handleScrollForDisplay, 10);
    window.addEventListener("scroll", this.handleDebouncedScrollDisplay);
  },

  methods: {
    handleScrollForDisplay () {
      if (window.scrollY > window.innerHeight) {
        this.display = true;
      } else {
        this.display = false;
      }
    },

    scrollToTop () {
      window.scrollTo(0, 0);
    },
  },
};
</script>
